<template>
  <div class="container" data-cy="team-members-invite-modal">
    <div class="title" v-if="!isOnboardingFlow">Invite members to team</div>
    <div class="subtitle" v-if="!isOnboardingFlow">Add or manage your team members and roles</div>
    <div class="subtitle" v-if="!isAllowedToInviteMembers">
      <an-link @click="changePlan" class="underline">Upgrade</an-link> to start collaborating.
    </div>
    <div class="body">
      <MembersForm showInviteWithLink />
    </div>
  </div>
</template>

<script>
import MembersForm from '@/components/Team/Settings/MembersForm';

export default {
  name: 'team-settings-members',
  props: {
    isOnboardingFlow: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MembersForm
  },
  computed: {
    theme() {
      return this.isOnboardingFlow ? 'dark' : 'light';
    },
    isAllowedToInviteMembers() {
      return this.$store.getters['teamMemberships/isAllowedToInviteMembers'];
    }
  },
  methods: {
    changePlan() {
      this.$trackEvent('team-members.upgrade.click');
      this.$router.push({ name: 'team-pricing', params: { teamSlug: this.$route.params.teamSlug } });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/_fullscreenLayout.scss';
</style>
